<div class="module-body">
  <div class="module-description" [innerHTML]="description"></div>
  <div *ngIf="useCases.length">
    <h3>Use cases</h3>
    <div #useCaseChips class="chip-container">
      <mat-chip class="use-case-chip" *ngFor="let useCase of useCases">
        {{ useCase }}
      </mat-chip>
    </div>
    <div *ngIf="useCaseExpandable">
      <brd-button color="no-border" text="See more" (click)="useCaseChips.classList.toggle('expanded')"></brd-button>
    </div>
  </div>
  <div *ngIf="functionalities.length">
    <h3>Functionalities included</h3>
    <div #functionalityChips class="chip-container">
      <mat-chip class="functionality-chip" *ngFor="let funct of functionalities">
        {{ funct }}
      </mat-chip>
    </div>
    <div *ngIf="functExpandable">
      <brd-button color="no-border" text="See more" (click)="functionalityChips.classList.toggle('expanded')"></brd-button>
    </div>
  </div>
</div>
